import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import { TrackType } from '@common/types/release/track-type';
import { UpdateTrackField } from '@webapp/store/tracks/action-creators';

import { AnimatePresence } from 'framer-motion';

import TextareaField from '@components/form/textarea';
import AnimatedHintCtrl from '@webapp/controllers/animated-hint';
import { Translate } from 'react-localize-redux';

interface LyricsCtrlProps {
  className?: string;
  trackId: string;
}

interface StoreProps {
  lyrics: string;
  isrcExists?: boolean;
  trackType: TrackType;
  onChange: (value: string) => UpdateTrackField<'lyrics'>;
}

const mapStateToProps = (state: AppState, props: LyricsCtrlProps) => {
  return {
    lyrics: state.tracks.tracks[props.trackId].lyrics || '',
    isrcExists: state.tracks.tracks[props.trackId]?.isrcExists,
    trackType: state.tracks.tracks[props.trackId].type || 'song',
  };
};

const mapDispatchToProps = (dispatch: Dispatch, props: LyricsCtrlProps) => {
  return {
    onChange: (value: string) =>
      dispatch(new UpdateTrackField<'lyrics'>(props.trackId, 'lyrics', value)),
  };
};

export const LyricsCtrl: React.FC<LyricsCtrlProps & StoreProps> = (props) => {
  const { lyrics, trackId, onChange } = props;
  const [changed, setChanged] = React.useState(false);
  const [value, setValue] = React.useState(lyrics);
  const [currentTrack, setCurrentTrack] = React.useState(trackId);

  React.useEffect(() => {
    if (trackId !== currentTrack) {
      setValue(lyrics);
      setCurrentTrack(trackId);
    }
  }, [trackId, currentTrack, lyrics]);

  const handleChange = (value: string) => {
    setValue(value);
    setChanged(true);
    onChange(value);
  };

  return props.trackType === 'instrumental' ? null : (
    <div className={props.className}>
      <TextareaField
        label={<Translate id="RELEASE.TRACK_INFO.TRACK.LYRICS" />}
        value={value}
        helpText="Optional"
        autoComplete="off"
        customBorderRadius={changed && lyrics ? '4px 4px 0 0' : undefined}
        onChange={handleChange}
        locked={props.isrcExists}
      />
      <AnimatePresence>
        {changed && lyrics ? (
          <AnimatedHintCtrl noBorderTop noMargin>
            <Translate id="RELEASE.TRACK_INFO.TRACK.LYRICS.HINT" />
          </AnimatedHintCtrl>
        ) : null}
      </AnimatePresence>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LyricsCtrl);
